import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { AlertCircle } from "lucide-react";

export const GeneralError = () => {
    return(
        <div className="flex m-auto py-4">
            <Alert variant="default">
                <AlertCircle className="w-h h-4"/>
                <AlertTitle>Error</AlertTitle>
            <AlertDescription>Ha ocurrido un error!, por favor intenta más tarde</AlertDescription>
            </Alert>
        </div>

    );
}